import {Component, OnInit, Output, Input, EventEmitter} from '@angular/core';
import * as moment from 'moment';
import * as XLSX from 'xlsx';
import {LocalStorageManager} from '../../../utils/local-storage-manager/local-storage-manager.utils';
import {FileExtension, FileType} from './interfaces/share-files.interfaces';
import {ShareFilesManager} from './models/share-files-manager.models';
import {SegmentedSelectorItem} from '../../common-components/segmented-selector/interfaces/segmented-selector.interfaces';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-modal-share-file',
  templateUrl: './modal-share-file.component.html',
  styleUrls: ['./modal-share-file.component.css']
})
export class ModalShareFileComponent implements OnInit {

  @Input() section: string | null = null;
  @Input() sharedFile?: ShareFilesManager;
  @Output() onEventEmitted = new EventEmitter<boolean>();

  isDarkmode = LocalStorageManager.isDarkmode;

  fileName = 'sharedData';

  extension: FileExtension = FileExtension.xls;
  extensions: SegmentedSelectorItem<FileExtension>[] = [
    {title: 'xlsx', value: FileExtension.xls},
    {title: 'csv', value: FileExtension.csv}
  ];


  constructor(private translate: TranslateService) {
    let lang = LocalStorageManager.lang;
    this.translate.use(lang!);
  }

  ngOnInit(): void {
    this.translate.get(this.section!).subscribe(translation => {
      this.fileName = translation + '-' + moment(new Date()).format('YYYYMMDDhhmm');
    });
  }

  setExtension(extension: FileExtension) {
    this.extension = extension;
  }

  export() {
    if (this.extension == FileExtension.xls) {
      this.exportXls();
    } else {
      this.exportCsv();
    }
    document.getElementById('btn-close-modal')?.click();
  }

  exportXls() {
    let workbook = XLSX.utils.book_new();
    let wsData = this.getWsDataXLSX();
    let ws = XLSX.utils.aoa_to_sheet(wsData);
    for (let cellId in ws) {
      if (cellId == '!ref') {
        break;
      }
      this.formatValues(cellId, ws);
    }
    const merge = this.sharedFile?.getMerge();
    ws['!merges'] = merge;
    XLSX.utils.book_append_sheet(workbook, ws, 'sheet1');
    let nameFile = this.fileName + '.' + this.extension;
    XLSX.writeFile(workbook, nameFile);
  }

  exportCsv() {
    let workbook = XLSX.utils.book_new();
    let wsData = this.getWsDataCSV();
    let ws = XLSX.utils.aoa_to_sheet(wsData);
    XLSX.utils.book_append_sheet(workbook, ws, 'Sheet1');
    let nameFile = this.fileName + '.' + this.extension;
    XLSX.writeFile(workbook, nameFile);
  }

  getWsDataXLSX() {
    let wsData: any[] = [
      [this.sharedFile?.getData()?.title],
      [this.getAccounts()],
      [this.sharedFile?.getData()?.title2],
      this.sharedFile?.getHeaders()
    ];
    this.sharedFile?.getData().forEach((data: any) => {
      wsData.push(data);
    });
    wsData.push([null]);
    wsData.push([null]);
    wsData.push(this.sharedFile?.balanceData());
    return wsData;
  }

  getWsDataCSV() {
    let wsData: any;
    if (this.sharedFile?.getData()?.fileType == FileType.schedule) {
      wsData = [
        ['Agenda'],
        [null],
        this.sharedFile.getHeaders()
      ];
    } else {
      wsData = [
        [this.sharedFile?.getData()?.title],
        this.sharedFile?.getHeaders()
      ];
    }

    this.sharedFile?.getData().forEach((data: any) => {
      wsData.push(data);
    });
    wsData.push([null]);
    wsData.push([null]);
    if (this.sharedFile?.getData()?.fileType == FileType.schedule) {
      wsData.push([null, null, 'Saldo: ' + (+this.sharedFile.getBalanceIncome() - +this.sharedFile.getBalanceExpense())]);
    } else {
      wsData.push(this.sharedFile?.balanceData());
    }
    return wsData;
  }

  getAccounts() {
    let accounts = this.sharedFile?.getData()?.accounts;
    let accountsNames = '';
    accounts?.forEach((account: any) => {
      if (accountsNames == '') {
        accountsNames = account.accountName;
      } else {
        accountsNames += ', ' + account.accountName;
      }
    });
    return accountsNames;
  }

  formatValues(cellId: any, ws: any) {
    if (cellId == 'A1') {
      ws[cellId].s = {
        font: {sz: 18, bold: true},
        alignment: this.getCenter()
      };
    } else if (cellId == 'A2' || cellId == 'A3') {
      ws[cellId].s = {
        font: {sz: 16},
        alignment: this.getCenter()
      };
    }/* else if (this.sharedFile?.getCoordinates().filter(headerTable => cellId == headerTable).length > 0) {
      ws[cellId].s = {
        fill: this.getFillHeader(),
        border: this.getBorder(),
        font: this.getFontHeader(),
        alignment: this.getCenter()
      }
    }*/ else {
      ws[cellId].s = {
        border: this.getBorder()
      };
    }
  }

  getBorder() {
    return {
      bottom: {
        style: 'thin',
        color: {rgb: '000000'}
      },
      top: {
        style: 'thin',
        color: {rgb: '000000'}
      },
      right: {
        style: 'thin',
        color: {rgb: '000000'}
      },
      left: {
        style: 'thin',
        color: {rgb: '000000'}
      }
    };
  }

  getFillHeader() {
    return {
      patternType: 'solid',
      fgColor: {rgb: '9999FF'},
    };
  }

  getFontHeader() {
    return {
      bold: true,
      sz: 14,
      color: '#F2F2F2'
    };
  }

  getCenter() {
    return {
      vertical: 'center',
      horizontal: 'center'
    };
  }
}
